import React from 'react'
import Grid from '@material-ui/core/Grid'
import cx from 'classnames'
import InfoToolTipIcon from './InfoToolTipIcon'
import Icon from 'components/shared/Icon'

const SelectEmailOptIn = ({ caEmails, handleChange }) => (
  <Grid container alignItems='center' className='pv6 ph5 pr0-t' spacing={1}>
    <Grid item xs={12} sm={7} md={6}>
      <EmailOptInTitle />
    </Grid>
    <Grid item xs={12} sm={5} md={6}>
      <EmailOptInRadioControls {...{ caEmails, handleChange }} />
    </Grid>
  </Grid>
)

const EmailOptInTitle = () => (
  <Grid container>
    <Grid item>
      <InfoToolTipIcon
        arrow
        title='This option allows you to opt out of receiving any News emails.'
      />
    </Grid>
    <span>Opt in or out of News emails</span>
  </Grid>
)

const EmailOptInRadioControls = ({ caEmails, handleChange }) => (
  <Grid container className='w-100'>
    <Grid item className='flex items-center'>
      <SelectOptIn
        checked={caEmails}
        onChange={() => handleChange('caEmails', true)}
      />
    </Grid>
    <Grid item className='flex items-center ml5'>
      <SelectOptOut
        checked={!caEmails}
        onChange={() => handleChange('caEmails', false)}
      />
    </Grid>
  </Grid>
)

const SelectOptIn = ({ checked, onChange }) => (
  <>
    <input
      className='dn' type='radio' name='caEmailOpt' id='caEmailIn' value='caEmailIn'
      {...{ checked, onChange }}
    />
    <label
      htmlFor='caEmailIn'
      className={cx(
        'mr6 mb0 lighter flex items-center account-input-label pointer',
        { 'account-input-checked': checked }
      )}
    >
      <Icon
        className='mr2 w7'
        name={{
          'icon-checkbox-marked-circle-outline': checked,
          'icon-checkbox-blank-circle-outline': !checked
        }}
      />
      <span className={cx({ teal: checked })}>In</span>
    </label>
  </>
)

const SelectOptOut = ({ checked, onChange }) => (
  <>
    <input
      className='dn' type='radio' name='caEmailOpt' id='caEmailOut' value='caEmailOut'
      {...{ checked, onChange }}
    />
    <label
      htmlFor='caEmailOut'
      className={cx(
        'mb0 lighter flex items-center account-input-label pointer',
        { 'account-input-checked': checked }
      )}
    >
      <Icon
        className='mr2 w7'
        name={{
          'icon-checkbox-marked-circle-outline': checked,
          'icon-checkbox-blank-circle-outline': !checked
        }}
      />
      <span className={cx({ teal: checked })}>Out</span>
    </label>
  </>
)

export default SelectEmailOptIn
